import { OutOptions } from './out-options.model';
import { Qna } from './qna.model';
import { PasswordState } from './password-state.model';

export class Account {
  outOptions: OutOptions;
  isAcceptedTerms: boolean;
  firstName: string;
  lastName: string;
  title: string;
  workPhone: string;
  mobilePhone: string;
  companyName: string;
  department: string;
  passwordState: PasswordState;
  street1: string;
  street2: string;
  country: string;
  state: string;
  city: string;
  zip: string;
  qna: Qna;
  pdfLanguage: string;
  email: string;
  resetGuid: string;
}
